const AccountMaxPostPublished = {
  Free:     2,
  Premium:  5,
  Ultimate: 15,
};

const AdType = {
  Post:      'Post',
  Url:       'Url',
  MediaOnly: 'Media Only',
  Stickers:  'Stickers',
  Page:      'Page',
  Highlight: 'Highlight',
  MapScreen: 'MapScreen',
  Custom:    'Custom',
};

const AreaType = {
  Street:      'Street',
  District:    'District',
  SubDistrict: 'Sub-district',
  MRT:         'MRT',
  Region:      'Region',
  Province:    'Province',
};

const BusinessPlan = {
  Free:     'Free',
  Premium:  'Premium',
  Ultimate: 'Ultimate',
};

const BusinessUserType = {
  Admin:       'Admin',
  Contributor: 'Contributor',
  Observer:    'Observer',
};

const Category = {
  EatAndDrink:       'Eat & Drink',
  Play:              'Play',
  Relax:             'Relax',
  Shop:              'Shop',
  TravelAndServices: 'Travel & Services',
};

const Colours = {
  Background: '#552181',
  Black:      '#000000',
  Grey:       '#6e6e6e',
  White:      '#FFF',
  Red:        '#FF0000',
  Gold:       '#FFD700',
};

const ContentType = {
  FormData:        'multipart/form-data',
  ApplicationJson: 'application/json',
};

const Error = {
  AccessDenied:            'Access Denied',
  IdRequired:              'Id is required',
  InterchangeDoesNotExist: 'Interchange does not exist',
  InterchangeRequired:     'Interchange is required',
  LevelRequired:           'Level is required',
  LinkTextRequired:        'Link text is required',
  LinkUrlRequired:         'Link URL is required',
  MapCoordBothOrNone:      'Both latitude and longitude must be filled or both left empty.',
  MapCoordInvalid:         'Please provide valid latitude and longitude values.',
  MinValidityPeriod:       'Validity period should at least be 1',
  NoInternetConnection:    'Your internet connection is unstable. Please ensure you have internet access & try again.',
  PathDoesNotExist:        'Path does not exist',
  PathRequired:            'Path is required',
  PostalCodeAlreadyExist:  'Postal code already exist',
  PostalCodeIsInvalid:     'Postal code is invalid',
  ReportToIT:              'Oops, something went wrong. Pls report to IT',
  SessionExpired:          'Session has expired. Please logout and login again.',
  SomethingWentWrong:      'Something went wrong',
  TypeInvalid:             'Type is invalid',
  TypeRequired:            'Type is required',
  UnexpectedError:         'Aww.. an unexpected error has occured. We are looking into this.',
  WaypointDoesNotExist:    'Waypoint does not exist',
  WaypointRequired:        'Waypoint is required',
};

const BinaryOneMBSize = 1048576;

const FileType = {
  Image:       'Image',
  Video:       'Video',
  Application: 'Application',
  Thumbnail:   'Thumbnail',
};

const GeographicTargetType = {
  NA:             'Not Applicable',
  Area:           'Area',
  Mall:           'Mall',
  AreaManagement: 'Area Management',
  Custom:         'Custom',
};

const GiftType = {
  Coupon:  'Coupon',
  Voucher: 'Voucher',
};
const IMAGE_FORMATS = ['image/jpeg', 'image/jpg', 'image/png'];

const MealTags = ['breakfast', 'lunch', 'high tea', 'dinner', 'supper'];

const PayProcessorType = {
  Mastercard: 'Mastercard',
  Visa:       'Visa',
  Amex:       'Amex',
  UnionPay:   'UnionPay',
};
const PayProcessor = Object.values(PayProcessorType);

const JobType = {
  Backend:           'Backend',
  MallScraper:       'Mall Scraper',
  FoodReviewScraper: 'Food Review Scraper',
};

const NotApplicable = 'Not applicable';

const HalalStatus = {
  No:             'No',
  HalalCertified: 'Halal Certified',
  MuslimOwned:    'Muslim Owned',
};

const ImageType = {
  Logo:           'Logo',
  Photo:          'Photo',
  VideoThumbnail: 'VideoThumbnail',
};

const MapType = {
  Deal: 'Deal Map',
  Food: 'Food Review Map',
};

const PageStatus = {
  Pending:  'Pending',
  Live:     'Live',
  Rejected: 'Rejected',
};

const PageType = {
  AreaManagement: 'Area Management',
  CreditCard:     'Credit Card',
  EventsCompany:  'Events Company',
  ECommerce:      'E-Commerce',
  FoodReview:     'Food Review',
  HawkerCentre:   'Hawker Centre',
  Mall:           'Mall',
  FNB:            'F&B',
  Photographer:   'Photographer',
  Retailer:       'Retailer',
  View:           'View',
};

const PostType = {
  Article: 'Article',
  Promo:   'Promo',
  Others:  'Others',
};

const PromoType = {
  Coupon:     'Coupon',
  CreditCard: 'Credit Card',
  Deals:      'Deals',
  Events:     'Events',
  LuckyDraw:  'Lucky Draw / Contest',
  NewLaunch:  'New Launch',
  PromoCode:  'Promo Code',
  Vouchers:   'Voucher',
};

const Status = {
  Accepted:    'Accepted',
  Activated:   'Activated',
  Approved:    'Approved',
  Expired:     'Expired',
  Deactivated: 'Deactivated',
  Draft:       'Draft',
  Live:        'Live',
  Pending:     'Pending',
  Rejected:    'Rejected',
  Redeemed:    'Redeemed',
  Unredeemed:  'Unredeemed',
};

const StaffPosition = {
  Associate:  'Associate',
  Contractor: 'Contractor',
  Developer:  'Developer',
  Manager:    'Manager',
  Scrapper:   'Scrapper',
  Super:      'Super',
};

const StaffType = {
  Admin:       'Admin',
  Contributor: 'Contributor',
  Observer:    'Observer',
};

const SortType = {
  Latest: 'Latest',
  Oldest: 'Oldest',

};

const OrderDir = {
  Latest: 'DESC',
  Oldest: 'ASC',
};

const PositionType = {
  Fixed:     'Fixed',
  Rotatable: 'Rotatable',
};

const PinnedPhotoLocation = {
  SnapstyrFavs: 'snapstyr-favs',
};

const PermissionsInit = [
  'adAdd', 'adRead', 'adUpdate', 'adDelete',
  'addressAdd', 'addressRead', 'addressUpdate', 'addressDelete',
  '-', 'analyticsRead', '--', '---',
  'areaAdd', 'areaRead', 'areaUpdate', 'areaDelete',
  '----', 'businessRead', 'businessUpdate', 'businessDelete',
  'categoryAdd', 'categoryRead', 'categoryUpdate', 'categoryDelete',
  'giftAdd', 'giftRead', 'giftUpdate', 'giftDelete',
  'highlightsAdd', 'highlightsRead', 'highlightsUpdate', 'highlightsDelete',
  'pageAdd', 'pageRead', 'pageUpdate', 'pageDelete',
  '-----', '------', 'officialPageUpdate', '-------',
  'postAdd', 'postRead', 'postUpdate', 'postDelete',
  'quickAdAdd', 'quickAdRead', 'quickAdUpdate', 'quickAdDelete',
  'scrappedPromoAdd', 'scrappedPromoRead', 'scrappedPromoUpdate', 'scrappedPromoDelete',
  'staffAdd', 'staffRead', 'staffUpdate', 'staffDelete',
  '--------', 'userModerationRead', 'userModerationUpdate', '---------',
  'tagAdd', 'tagRead', 'tagUpdate', 'tagDelete',
  'trailAdd', 'trailRead', 'trailUpdate', 'trailDelete',
  'mobileAppAdd', 'mobileAppRead', 'mobileAppUpdate', 'mobileAppDelete',
  'mobileAppVersionAdd', 'mobileAppVersionRead', 'mobileAppVersionUpdate', 'mobileAppVersionDelete',
  'giveawayWinnerAdd', 'giveawayWinnerRead', 'giveawayWinnerUpdate', 'giveawayWinnerDelete',
  'reviewAdd', 'reviewRead', 'reviewUpdate', 'reviewDelete',
  'loyaltyCardAdd', 'loyaltyCardRead', 'loyaltyCardUpdate', 'loyaltyCardDelete',
  'luckyDrawAdd', 'luckyDrawRead', 'luckyDrawUpdate', 'luckyDrawDelete',
  '----------', 'promoCodeRead', 'promoCodeUpdate', 'promoCodeDelete',
  'poiAdd', 'poiRead', 'poiUpdate', 'poiDelete',
  'photoAdd', 'photoRead', 'photoUpdate', 'photoDelete',
  'albumAdd', 'albumRead', 'albumUpdate', 'albumDelete',
  '-----------', 'commentRead', 'commentUpdate', '------------',
  '-------------', 'pinnedPhotoRead', 'pinnedPhotoUpdate', '--------------',
];

const Url = {
  Album:              '/admin/page/:pageId/album/:id',
  Albums:             '/admin/page/:pageId/albums',
  Business:           '/admin/business',
  BusinessDetails:    '/admin/business/pageClaim/:pageClaimId',
  Page:               '/admin/page/:pageId',
  PageHighlight:      '/admin/page/:pageId/highlight/:pageHighlightId',
  PageHighlights:     '/admin/page/:pageId/highlights',
  SnapstyrFavs:       '/admin/snapstyr-favs',
  Post:               '/admin/page/:pageId/post/:postId',
  Trails:             '/admin/page/:pageId/trails',
  Trail:              '/admin/page/:pageId/trail/:trailId',
  Gift:               '/admin/page/:pageId/vouchers-coupons/:giftId',
  LoyaltyCards:       '/admin/page/:pageId/loyaltyCards',
  LoyaltyCard:        '/admin/page/:pageId/loyaltyCards/:loyaltyCardId',
  LuckyDraws:         '/admin/page/:pageId/luckyDraws',
  LuckyDraw:          '/admin/page/:pageId/luckyDraws/:luckyDrawId',
  Review:             '/admin/page/:pageId/review/:reviewId',
  VouchersAndCoupons: '/admin/page/:pageId/vouchers-coupons',
};

const Success = 'Success';

const CrossOrigin = 'anonymous';

const mobileAppVersionType = {
  Compulsory: 'Compulsory',
  Optional:   'Optional',
};

const CacheTypeText = {
  clearAllCache:      'Clear All Cache',
  clearSpecificCache: 'Specific Cache',
  highlights:         'Highlights',
  ads:                'Ads',
  searchTrends:       'Search Trends',
  specificPostById:   'Specific post by id',
  allPostKeys:        'All post keys',
  specificPageById:   'Specific page by id',
  allPageKeys:        'All page keys',
  allPublicPostKeys:  'All public post keys',
};

const CacheTypeName = {
  clearAllCache:      'clearAllCache',
  clearSpecificCache: 'clearSpecificCache',
  highlights:         'highlights',
  ads:                'ads',
  searchTrends:       'searchTrends',
  specificPostById:   'specificPostById',
  allPostKeys:        'allPostKeys',
  specificPageById:   'specificPageById',
  allPageKeys:        'allPageKeys',
  allPublicPostKeys:  'allPublicPostKeys',
};

const WaypointType = {
  Store:          'Store',
  Path:           'Path',
  MaleToilet:     'Male Toilet',
  FemaleToilet:   'Female Toilet',
  HandicapToilet: 'Handicap Toilet',
  Babycare:       'Babycare',
  SalatRoom:      'Salat Room',
  Information:    'Information',
  ATM:            'ATM',
  Staircase:      'Staircase',
  Lift:           'Lift',
  Escalator:      'Escalator',
  Gate:           'Gate',
  TaxiStand:      'Taxi Stand',
  Walkpoint:      'Walkpoint',
};

const MallMapManageButtons = {
  MANAGE_LEVELS:    'MANAGE_LEVELS',
  MANAGE_WAYPOINTS: 'MANAGE_WAYPOINTS',
  MANAGE_LINKS:     'MANAGE_LINKS',
};

const SpecialHighlightPostType = {
  PicMarker: 'PicMarker',
  Pinned:    'Pinned',
  Special:   'Special',
};

/**
 * Update this "MallNameMapping" constant, whenever a new "*.glb" file is added in /public/models directory
 * Make sure you have the "*.glb" files in /public/models directory in "Website" too
 *
 * These value are used to show the correct mall map to user, and also used when creating a new MallMap record
 */
const MallNameMapping = [
  'Northpoint-City-Level-1.glb',
  'Northpoint-City-Level-2.glb',
];

const TrailType = {
  Food:   'Food',
  Hawker: 'Hawker',
};

const TrailItemType = {
  Post:   'Post',
  Review: 'Review',
};

const SDB = 'SDB';

const ModerationTypes = {
  Id:       'id',
  Username: 'username',
  Email:    'email',
};

const Constants = {
  AccountMaxPostPublished,
  AdType,
  AreaType,
  BinaryOneMBSize,
  BusinessPlan,
  BusinessUserType,
  CacheTypeText,
  CacheTypeName,
  Category,
  Colours,
  ContentType,
  CrossOrigin,
  Error,
  FileType,
  GeographicTargetType,
  GiftType,
  MealTags,
  NotApplicable,
  HalalStatus,
  ImageType,
  JobType,
  MapType,
  mobileAppVersionType,
  OrderDir,
  PageStatus,
  PageType,
  PayProcessor,
  PayProcessorType,
  PermissionsInit,
  PinnedPhotoLocation,
  PostType,
  PromoType,
  PositionType,
  Status,
  StaffPosition,
  Success,
  SortType,
  StaffType,
  TrailType,
  TrailItemType,
  Url,
  WaypointType,
  MallMapManageButtons,
  MallNameMapping,
  SpecialHighlightPostType,
  IMAGE_FORMATS,
  SDB,
  ModerationTypes,
};

module.exports = Constants;
